import React, { useEffect, useState } from "react";
import "./style.css";
import LeftPanel from "../../Components/AiChatbot/LeftPanel";
import ChatScreen from "../../Components/AiChatbot/ChatScreen";
import RightPanel from "../../Components/AiChatbot/RightPanel";
import { Layout } from "@arco-design/web-react";
import { chatbotsettings } from "../../Functions/Utils";
import { ToastContainer } from "react-toast";

function AiChatbot() {
  const [isLeftPanelVisible, setIsLeftPanelVisible] = useState(false);
  const [versionValue, setVersionValue] = useState({
    label: "Multi Source",
    value: "multi_source",
    key: "v6",
    attachOption: ["pdf", "docs"],
  });

  const [timestamp, setTimestamp] = useState(null);

  const [clearChatState, setClearChatState] = useState(false);

  const handleClearChat = () => {
    setClearChatState(true); // Set the flag to true to clear the chat
  };

  const resetClearChatState = () => {
    setClearChatState(false); // Reset the flag after clearing
  };

  useEffect(() => {
    const currentTimestamp = Date.now();
    setTimestamp(currentTimestamp);
  }, []);

  const toggleLeftPanel = () => {
    setIsLeftPanelVisible(!isLeftPanelVisible);
  };

  const handleVersionChange = (value) => {
    setVersionValue(value); // Update shared state
  };

  return (
    <>
      <Layout className="h_100svh layoutMain chatLayout">
        <div className="h-100 p-3">
          <div className="d-flex gap-2 h-100 w-100">
            <LeftPanel
              isVisible={isLeftPanelVisible}
              toggleVisibility={toggleLeftPanel}
              selectedVersion={versionValue}
              onClearChat={handleClearChat}
            />
            <ChatScreen
              uniqueId={timestamp}
              toggleLeftPanel={toggleLeftPanel}
              chatbotsettings={chatbotsettings}
              onVersionChange={handleVersionChange}
              clearChatState={clearChatState}
              onClearChatHandled={resetClearChatState}
            />
            {chatbotsettings?.enableHistory && <RightPanel />}
          </div>
        </div>
        <ToastContainer delay={4000} position="top-right" />
      </Layout>
    </>
  );
}

export default AiChatbot;
